module.exports = __webpack_public_path__ + "static/img/xc2.1339200.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xc2.png
// module id = o4DC
// module chunks = 0